import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../../shared/api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../../shared/api/firebase/references";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";

export interface NarAgentGridInsuranceOption {
  value: string;
  label: string;
}

/** Load payer options shared by the NAR Agent Grid and Historic NAR screens. */
const useNarAgentGridInsuranceOptions = () => {
  const [insuranceOptions, setInsuranceOptions] = useState<
    NarAgentGridInsuranceOption[]
  >([]);

  useEffect(() => {
    const fetchInsuranceOptions = async () => {
      try {
        const options = await FirestoreService.getDocument(
          FirestoreDocumentReference.insuranceOptions("payer_mapping"),
        );
        setInsuranceOptions(
          Object.keys(options as object)
            .filter((key) => key !== "id")
            .sort()
            .map((key) => ({
              value: key,
              label: capitalizeWordsSeperatedByUnderScore(key),
            })),
        );
      } catch (error) {
        console.error("Error fetching insurance options:", error);
      }
    };
    void fetchInsuranceOptions();
  }, []);

  return { insuranceOptions };
};

export default useNarAgentGridInsuranceOptions;
